<template>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <ConfirmDialog />
    <div class="flex align-items-center justify-content-between mb-4">
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>Órdenes de Producción</strong>
      </span>
      <Button 
        label="Nueva Orden" 
        icon="pi pi-plus" 
        class="p-button-success" 
        @click="goToNuevaOrden" 
      />
    </div>

    <!-- Tabla de resultados -->
    <div class="mt-4">
      <DataTable
        :value="ordenesList"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        stripedRows
        rowHover
        showGridlines
        emptyMessage="No se encontraron órdenes de producción."
      >
        <Column field="nro_orden" header="NRO ORDEN" :sortable="true"></Column>
        <Column header="FECHA" :sortable="true">
          <template #body="{ data }">
            {{ data.created_at ? new Date(data.created_at).toLocaleDateString() : '' }}
          </template>
        </Column>
        <Column header="SUCURSAL" :sortable="true">
          <template #body="{ data }">
            {{ data.sucursal ? (data.sucursal.nombre || data.sucursal.descripcion) : '-' }}
          </template>
        </Column>
        <Column header="PRODUCTO" :sortable="true">
          <template #body="{ data }">
            {{ data.producto_resultante ? (data.producto_resultante.descripcion || data.producto_resultante.nombre) : '-' }}
          </template>
        </Column>
        <Column header="CANTIDAD" :sortable="true">
          <template #body="{ data }">
            {{ parseFloat(data.cantidad_real) || 0 }} {{ (data.gramaje_unidad && parseFloat(data.gramaje_unidad) > 0) ? 'porciones' : 'un.' }}
          </template>
        </Column>
        
        <Column field="estado" header="ESTADO" :sortable="true">
          <template #body="{ data }">
            <Tag 
              :value="getSeverity(data.estado).text" 
              :severity="getSeverity(data.estado).class" 
            />
          </template>
        </Column>

        <Column header="ACCIONES" :exportable="false" style="min-width:8rem">
          <template #body="{ data }">
            <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text" title="Anular orden" @click="confirmarAnular(data)" :disabled="data.estado === 4" />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Tag from 'primevue/tag';
import ProduccionService from '@/service/ProduccionService';
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";

// Enrutador para navegación
const router = useRouter();
const toast = useToast();
const confirm = useConfirm();
const produccionService = new ProduccionService();

const ordenesList = ref([]);

const cargarOrdenes = async () => {
  try {
    const res = await produccionService.getOrdenesProduccion();
    if (res && res.success) {
      ordenesList.value = res.data.data || res.data;
    }
  } catch (error) {
    console.error("Error cargando órdenes:", error);
  }
};

onMounted(() => {
  cargarOrdenes();
});

const goToNuevaOrden = () => {
  router.push('/produccion/nueva');
};

const confirmarAnular = (orden) => {
  confirm.require({
    message: `¿Estás seguro de que deseas anular la orden ${orden.nro_orden}?`,
    header: 'Confirmar Anulación',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      anularOrden(orden.id);
    },
  });
};

const anularOrden = async (id) => {
  try {
    const res = await produccionService.anularOrdenProduccion(id, 'Anulado por usuario desde lista');
    if (res && (res.success === true || res.status === 200 || res.status === 'success')) {
      toast.add({ severity: 'success', summary: 'Anulada', detail: res.message || 'La orden fue anulada correctamente.', life: 3000 });
      cargarOrdenes();
    } else {
      const msg = res?.message || res?.msg || 'No se pudo anular la orden.';
      toast.add({
        severity: 'error',
        summary: 'Error al anular',
        detail: msg,
        life: 6000
      });
    }
  } catch (error) {
    const mensajeError =
      (typeof error === 'string' ? error : null) ||
      error?.response?.data?.message ||
      error?.message ||
      'No se pudo anular la orden.';
    toast.add({
      severity: 'error',
      summary: 'Error al anular',
      detail: mensajeError,
      life: 6000
    });
  }
};

const getSeverity = (estado) => {
  switch (Number(estado)) {
    case 1: return { text: 'PLANIFICADO', class: 'info' };
    case 2: return { text: 'EN PROCESO', class: 'warning' };
    case 3: return { text: 'FINALIZADO', class: 'success' };
    case 4: return { text: 'ANULADO', class: 'danger' };
    default: return { text: 'DESCONOCIDO', class: 'secondary' };
  }
};
</script>

<style scoped>
</style>
